"use client";

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/core/components/ui/sheet";
import { useTranslation } from "react-i18next";
import type { Excess3MonthsResponse } from "../services/excess-3-months-service";
import { ExceededCreditsCardModalCompanyPlan } from "./exceeded-credits-card-modal-company-plan";
import { ExceededCreditsCardModalUsedValues } from "./exceeded-credits-card-modal-used-values";
import { ExceededCreditsCardModalChart } from "./exceeded-credits-card-modal-chart";

export type ExceededCreditsModalDetailsProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  data: Excess3MonthsResponse | null;
};

export function ExceededCreditsModalDetails({
  open,
  onOpenChange,
  data,
}: ExceededCreditsModalDetailsProps) {
  const { t } = useTranslation(["dashboard"]);

  const pkg = data?.package;
  const excessValue = data?.last_month?.excess_value ?? 0;
  const excessPercentage = data
    ? Math.round(data.last_month.excess_percentage * 100)
    : 0;
  const consumptionMonths = data?.consumption_percentage_months ?? [];

  if (!pkg) {
    return (
      <Sheet open={open} onOpenChange={onOpenChange}>
        <SheetContent side="right" className="overflow-y-auto">
          <SheetHeader>
            <SheetTitle>
              {t("exceeded-credits-modal-title", "Consumo acima do contratado")}
            </SheetTitle>
            <SheetDescription asChild>
              <p>{t("exceeded-credits-modal-loading")}</p>
            </SheetDescription>
          </SheetHeader>
        </SheetContent>
      </Sheet>
    );
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="overflow-y-auto !min-w-[800px] max-w-[90vw]"
      >
        <SheetHeader>
          <SheetTitle className="text-xl font-semibold">
            {t("exceeded-credits-modal-title", "Consumo acima do contratado")}
          </SheetTitle>
          <SheetDescription asChild>
            <p className="text-sm text-muted-foreground mt-1">
              {t(
                "exceeded-credits-modal-subtitle",
                "Seu padrão atual está gerando uso excedente recorrente.",
              )}
            </p>
          </SheetDescription>
        </SheetHeader>

        <div className="space-y-6 mt-4">
          <ExceededCreditsCardModalCompanyPlan
            totalCredits={pkg.total_credits}
            creditUnitPrice={pkg.credit_unit_price}
            totalValue={pkg.total_value}
            packageId={pkg.id}
          />

          <ExceededCreditsCardModalUsedValues
            excessValue={excessValue}
            excessPercentage={excessPercentage}
          />

          <ExceededCreditsCardModalChart
            consumptionMonths={consumptionMonths}
            totalCredits={pkg.total_credits}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
}
